export enum AllowableFreightExtensionPropertyKeys {
    AllowableFreightThresholdTotalKey = 'AllowableFreightThresholdTotal',
    AllowableFreightThresholdAmountKey = 'AllowableFreightThresholdAmount',
    AllowableFreightIsUnitCountKey = 'IsUnitCount',
    AllowableFreightIsFreightActiveKey = 'IsAllowableFreightActive',
    AllowableFreightStatusType = 'StatusType'
}
